import { ApiService } from '@services/api';
import { API_DOMAIN } from '@constants/api';
import {
  IGetCredentialProps,
  ICreateCredentialProps,
  IGenerateURLProps,
  IUpdateCredentialProps,
} from '@domain/interfaces/dashboard/IntegrationCenter/InfoProduct/Platforms/IKiwifyAuth';

export class KiwifyService {
  private readonly apiService: ApiService;

  constructor(baseURL: string) {
    this.apiService = new ApiService(baseURL);
  }

  public getCredential({ storeAliasId }: IGetCredentialProps): Promise<any> {
    return this.apiService.get(`/api/v1/users/stores/${storeAliasId}/kiwify-credentials`);
  }

  public createCredential({ storeAliasId, data }: ICreateCredentialProps): Promise<any> {
    return this.apiService.post(`/api/v1/users/stores/${storeAliasId}/kiwify-credentials`, {
      ...data,
    });
  }

  public updateCredential({
    storeAliasId,
    credentialAliasId,
    data,
  }: IUpdateCredentialProps): Promise<any> {
    return this.apiService.put(
      `/api/v1/users/stores/${storeAliasId}/kiwify-credentials/${credentialAliasId}`,
      {
        ...data,
      },
    );
  }

  public generateWebhookURL({ storeAliasId }: IGenerateURLProps): Promise<any> {
    return this.apiService.post(
      `/api/v1/users/stores/${storeAliasId}/kiwify-credentials/generate-webhook-url`,
    );
  }
}

const kiwifyService = new KiwifyService(API_DOMAIN);

export default kiwifyService;
